import React from 'react'

const TableHeaderButton = ({ Icon, text, onClick, className }) => {
    return (
        <button className={`btn btn-xs btn-outline outline outline-1 ${className ? className : ''}`} onClick={onClick}>
            {Icon && Icon}
            <span className='text-sm'>{text}</span>
        </button>
    )
}

export default TableHeaderButton
